import React from 'react';
import SubscriptionSetupInitial from './SubscriptionSetupInitial';
import SubscriptionSetupProcessed from './SubscriptionSetupProcessed';
import SubscriptionSetupProcessing from './SubscriptionSetupProcessing';
import { useSubscriptionSetupContext } from '../SubscriptionSetupContext';
import SubscriptionSetupFailed from './SubscriptionSetupFailed';

const SubscriptionSetupContentSwitch = () => {
  const {
    paymentProcessed,
    isProcessing,
    hasProcessingError,
  } = useSubscriptionSetupContext();

  if (paymentProcessed) {
    return (
      <SubscriptionSetupProcessed />
    );
  }

  return (
    <React.Fragment>
      {(hasProcessingError) ? <SubscriptionSetupFailed /> : null}
      {(isProcessing) ? <SubscriptionSetupProcessing /> : null}
      <SubscriptionSetupInitial
        hidden={hasProcessingError || isProcessing}
      />
    </React.Fragment>
  );
};

export default SubscriptionSetupContentSwitch;
